if (!customElements.get('apex-pickup-availability')) {
  customElements.define(
    'apex-pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();
        const that = this;
        //if (!this.hasAttribute('available')) return;

        //this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.variantId = this.dataset.variantId;

        //if domcontentloaded has already fired, fetch the availability
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            that.fetchAvailability(that.dataset.variantId);
          });
        } else {
          this.fetchAvailability(this.dataset.variantId);
        }
      }

      updateTotalQuantity(qty) {
        const els = this.querySelectorAll('.inventory-total-quantity');
        els.forEach((el) => {
          //format it for locale en-us
          el.innerHTML = qty.toLocaleString('en-US');
        });
      }

      fetchAvailability(variantId) {
        const that = this;

        let rootUrl = Shopify.routes.root;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
            this.variantId = variantId;
            this.classList.remove('hidden');
          })
          .catch((e) => {
            console.log('error fetching availability', e);
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
            that.classList.remove('hidden');
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = '';
        //this.appendChild(this.errorHtml);

        //this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();

        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        const jsonElement = sectionInnerHTML.querySelector('#pickup-availability-inventory-json');

        if (jsonElement) {
          const jsonData = JSON.parse(jsonElement.innerHTML);
          const qtyAvailableDisplay = this.querySelector('.quantities-available-display');
          const fulfillmentOptionSummary = this.querySelector('.fulfillment-option-summary');
          let totalQuantity = 0,
            shipQuantity = 0,
            pickupQuantity = 0;

          jsonData.forEach((entry) => {
            const locationQty = parseInt(entry.quantity, 10);
            totalQuantity += locationQty;
            const locationId = entry.location.id;
            const locationElement = document.querySelector(
              `.pickup-availability-list__item[data-location-id="${locationId}"]`
            );
            if (locationElement) {
              pickupQuantity += locationQty;
              if (locationQty > 0) {
                locationElement.querySelector('.item-available-info').innerHTML = `<span>${locationQty.toLocaleString(
                  'en-US'
                )}</span> in stock`;
                locationElement.querySelector('.item-available').classList.remove('hidden');
                locationElement.querySelector('.item-unavailable').classList.add('hidden');
              } else {
                locationElement.querySelector(
                  '.item-available-info'
                ).innerHTML = `<span>${locationQty}</span> in stock`;
                locationElement.querySelector('.item-available').classList.add('hidden');
                locationElement.querySelector('.item-unavailable').classList.remove('hidden');
              }
            }
          });

          if (totalQuantity) {
            const updateQtyElements = this.querySelectorAll(`.inventory-total-quantity`);
            updateQtyElements.forEach((el) => (el.innerHTML = totalQuantity.toLocaleString('en-US')));
            shipQuantity = totalQuantity - pickupQuantity;

            if (shipQuantity > 0 && pickupQuantity > 0) {
              const pickupQtyElement = this.querySelector('.pickup-available-quantity');
              const shippingQtyElement = this.querySelector('.shipping-available-quantity');

              if (pickupQtyElement) {
                if (pickupQuantity > 0) {
                  pickupQtyElement.innerHTML = pickupQuantity.toLocaleString('en-US');
                  pickupQtyElement.closest('ul').classList.remove('hidden');
                }
              }
              if (shippingQtyElement) {
                if (shipQuantity > 0) {
                  shippingQtyElement.innerHTML = shipQuantity.toLocaleString('en-US');
                  shippingQtyElement.closest('ul').classList.remove('hidden');
                }
              }
              if (qtyAvailableDisplay) {
                qtyAvailableDisplay.classList.remove('hidden');
              }
            } else {
              console.log('some qty is 0');
              if (fulfillmentOptionSummary) {
                if (shipQuantity > 0) {
                  fulfillmentOptionSummary.innerHTML = window.fulfillmentStrings.onlyShippingAvailable;
                } else if (pickupQuantity > 0) {
                  fulfillmentOptionSummary.innerHTML = window.fulfillmentStrings.onlyPickupAvailable;
                } else {
                  fulfillmentOptionSummary.innerHTML = '';
                }
              }

              if (qtyAvailableDisplay) {
                qtyAvailableDisplay.classList.add('hidden');
              }
            }
          }
        } else {
          console.log('no json el');
        }

        /*document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector('pickup-availability-drawer').classList.add(colorClass);
        });

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
        */
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}
